import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  async createTestDrive({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'createTestDrive', () =>
      http.post('admin/createTestDrive', data)
    )
    commit(types.SET_TESTDRIVE_ID, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/testdrive/actions.js